const Footer = () => {
  return (
    <footer>
      This project was coded by Oksana Bolbat and is open-sourced on{' '}
      <a href="https://github.com/oksanabolbat/react-weather-app">GitHub</a> and
      hosted on <a href="https://www.netlify.com/">Netlify</a>
    </footer>
  );
};
export default Footer;
